import React from 'react';
import { routes as r } from '../../../routes';
import { SchedulerShiftsCalendar } from '../SchedulerShiftsCalendar';

export const routes = () => ({
  schedulerShifts: {
    route: r.schedulerShifts.route,
    render: () => <SchedulerShiftsCalendar />,
  },
});
